import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import Home from "../pages/Home";
import Quiz from "../pages/Quiz";
import Results from "../pages/Results";
import appStatePersistenceService from "../services/appStatePersistenceService";

// Component that handles post-login restoration (must be inside Router)
const RestoreStateHandler = ({ children }) => {
  const navigate = useNavigate();
  const [hasRestored, setHasRestored] = React.useState(false);

  useEffect(() => {
    // Only run restoration once
    if (hasRestored) {
      console.log("[RestoreState] Already restored, skipping");
      return;
    }

    // Check if user is returning from login and restore their state
    const restoreStateAfterLogin = async () => {
      try {
        console.log("[RestoreState] Checking for saved state...");
        console.log("[RestoreState] Current URL:", window.location.href);

        const savedState = await appStatePersistenceService.restoreAppState();
        if (savedState) {
          console.log(
            "[RestoreState] Found saved state, restoring:",
            savedState,
          );
          setHasRestored(true);

          // Extract the path we should navigate to
          let targetPath = "/";
          if (savedState.pathname) {
            targetPath =
              savedState.pathname +
              (savedState.search || "") +
              (savedState.hash || "");
          }

          console.log("[RestoreState] Target path:", targetPath);
          console.log("[RestoreState] Current path:", window.location.pathname);

          // Only navigate if we're not already on the target path
          if (window.location.pathname !== savedState.pathname) {
            console.log("[RestoreState] Navigating to:", targetPath);
            // Small delay to ensure React Router is ready
            setTimeout(() => {
              navigate(targetPath, { replace: true });

              // Restore scroll position after navigation
              if (savedState.scrollPosition) {
                setTimeout(() => {
                  console.log(
                    "[RestoreState] Restoring scroll position:",
                    savedState.scrollPosition,
                  );
                  window.scrollTo(
                    savedState.scrollPosition.x,
                    savedState.scrollPosition.y,
                  );
                }, 300);
              }
            }, 100);
          } else {
            console.log(
              "[RestoreState] Already on target path, only restoring scroll",
            );
            // Just restore scroll if we're already on the right page
            if (savedState.scrollPosition) {
              setTimeout(() => {
                window.scrollTo(
                  savedState.scrollPosition.x,
                  savedState.scrollPosition.y,
                );
              }, 300);
            }
          }
        } else {
          console.log("[RestoreState] No saved state found");
          setHasRestored(true);
        }
      } catch (error) {
        console.error(
          "[RestoreState] Error restoring state after login:",
          error,
        );
        setHasRestored(true);
      }
    };

    restoreStateAfterLogin();
  }, [navigate, hasRestored]);

  return children;
};

const AppRouter = () => (
  <Router basename="/tools/elisabuilder">
    <RestoreStateHandler>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/healthcheck"
          element={<h1>Elisa builder is running</h1>}
        />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/results" element={<Results />} />
      </Routes>
    </RestoreStateHandler>
  </Router>
);

export default AppRouter;
